<app-ds-button
  tone="ghost"
  size="sm"
  class="header-icon-btn"
  [matBadge]="(cartItem$ | async)?.length"
  [ariaLabel]="'cart' | translate"
  (pressed)="cartToggle(true)"
>
  <mat-icon class="header-icon">shopping_bag</mat-icon>
</app-ds-button>

<!-- Cart On Hover -->
<div
  class="onhover-div"
  [ngClass]="{ 'fixed-cart': cartStyle == 'cart_sidebar' }"
  [class.show]="sidebarCartOpen$ | async"
>
  <div class="cart-title">
    <div class="cart-title__left">
      <mat-icon class="cart-title__icon">shopping_bag</mat-icon>
      <span class="cart-title__text">{{ "cart" | translate }}</span>
      @if ((cartItem$ | async)?.length) {
        <span class="cart-title__count">{{ (cartItem$ | async)?.length }}</span>
      }
    </div>
    <app-ds-button
      tone="ghost"
      size="sm"
      class="cart-close-btn"
      [ariaLabel]="'close' | translate"
      (pressed)="cartToggle(false)"
    >
      <mat-icon>close</mat-icon>
    </app-ds-button>
  </div>
  
  <!-- Skeleton Loading -->
  <div class="skeleton-loader" *ngIf="loader">
    <div class="skeleton-item" *ngFor="let i of [1,2,3]">
      <div class="skeleton-image"></div>
      <div class="skeleton-content">
        <div class="skeleton-title"></div>
        <div class="skeleton-subtitle"></div>
        <div class="skeleton-price"></div>
      </div>
    </div>
  </div>
  
  <ul class="cart-list" *ngIf="(cartItem$ | async)?.length && !loader">
    <li class="product-box-contain" 
        *ngFor="let item of cartItem$ | async"
        [@slideInOut]>
      <div class="drop-cart">
        <img
          [src]="item?.imageUrl ? item.imageUrl : 'assets/images/product.png'"
          class="cart-product-image"
          aria-hidden="true"
        />
        <div class="drop-contain">
          <p class="cart-description mt-4">
            {{ item.name }}
          </p>
          <p class="mb-1">
            <span class="cart-description">{{ "size" | translate }}:</span>
            {{ item.size | translate }}
          </p>
          <p class="mb-1">
            <span class="cart-description">{{ "color" | translate }}:</span>
            {{ item.color | translate }}
          </p>

          <p class="mb-4 cart-total-value">
            <span class="cart-description"
              >{{ "original_total_value" | translate }}:
            </span>
            {{ item.total_price | currency: "BRL" : "symbol" : "1.2-2" }}
          </p>

          <div class="cart-quantity-controls">
            <div class="quantity-container">
              <app-ds-button
                tone="ghost"
                size="sm"
                class="qty-btn minus-btn"
                (pressed)="removeQuantity(item)"
                [disabled]="item.quantity <= 1"
              >
                <mat-icon>remove</mat-icon>
              </app-ds-button>
              <input
                class="qty-input"
                type="number"
                [value]="item?.quantity"
                min="1"
                max="99"
                readonly
              />
              <app-ds-button
                tone="ghost"
                size="sm"
                class="qty-btn plus-btn"
                (pressed)="addQuantity(item)"
              >
                <mat-icon>add</mat-icon>
              </app-ds-button>
              <app-ds-button
                tone="ghost"
                size="sm"
                class="qty-btn delete-btn"
                [ariaLabel]="'remove_from_cart' | translate"
                (pressed)="removeItemFromCart(item)"
              >
                <mat-icon>delete</mat-icon>
              </app-ds-button>
            </div>
          </div>
        </div>
      </div>
    </li>
  </ul>
  <div class="empty-cart-box" *ngIf="!(cartItem$ | async)?.length && !loader">
    <mat-icon class="empty-cart-icon">shopping_bag</mat-icon>
    <h5>{{ "your_cart_is_currently_empty" | translate }}</h5>
    <p class="empty-cart-hint">{{ "add_products_to_start" | translate }}</p>
  </div>
  
  <div class="bottom-box" 
       *ngIf="(cartItem$ | async)?.length"
       [class.success-feedback]="showSuccessFeedback">
    <p class="free">
      {{ "shipping_and_taxes_are_calculated_at_checkout" | translate }}
    </p>
    <div class="price-box">
      <h5>{{ "total" | translate }}:</h5>
      <h4 class="fw-bold">
        {{ (cartTotal$ | async)! | currency: "BRL" : "symbol" : "1.2-2" }}
      </h4>
    </div>
    <div class="button-group">
      <app-ds-button
        tone="secondary"
        [routerLink]="['/shop/cart']"
        (pressed)="cartToggle(false)"
      >
        {{ "view_cart" | translate }}
      </app-ds-button>
      <app-ds-button
        tone="primary"
        [routerLink]="['/shop/checkout']"
        (pressed)="checkout()"
      >
        {{ "checkout" | translate }}
      </app-ds-button>
    </div>
  </div>
</div>
<div
  class="bg-overlay"
  [class.show]="cartStyle == 'cart_sidebar' && (sidebarCartOpen$ | async)"
  (click)="cartStyle == 'cart_sidebar' && cartToggle(false)"
></div>
<div
  class="confetti-wrapper"
  [class.show]="confetti == 1 && (sidebarCartOpen$ | async)"
>
  <ng-container *ngFor="let item of confettiItems">
    <div class="confetti-{{ item }}"></div>
  </ng-container>
</div>
